import api from './api'

const adminService = {
  // ============================================================
  // Report Management
  // ============================================================

  /**
   * Get all reports with optional filters
   * @param {Object} params - Query parameters
   * @param {string} [params.status] - Filter by status (pending, reviewed, dismissed, actioned)
   * @param {string} [params.reason] - Filter by reason
   * @param {number} [params.page=1] - Page number
   * @param {number} [params.per_page=20] - Items per page
   */
  getReports: async (params = {}) => {
    const response = await api.get('/admin/reports', { params })
    return response.data
  },

  /**
   * Get a specific report
   * @param {number} reportId - Report ID
   */
  getReport: async (reportId) => {
    const response = await api.get(`/admin/reports/${reportId}`)
    return response.data
  },

  /**
   * Update a report (status, admin notes)
   * @param {number} reportId - Report ID
   * @param {Object} data - Update data
   * @param {string} [data.status] - New status
   * @param {string} [data.admin_notes] - Admin notes
   */
  updateReport: async (reportId, data) => {
    const response = await api.put(`/admin/reports/${reportId}`, data)
    return response.data
  },

  // ============================================================
  // Global Hide Management
  // ============================================================

  /**
   * Get globally hidden scorables
   * @param {Object} params - Query parameters
   * @param {number} [params.page=1] - Page number
   * @param {number} [params.per_page=20] - Items per page
   */
  getHiddenScorables: async (params = {}) => {
    const response = await api.get('/admin/hidden-scorables', { params })
    return response.data
  },

  /**
   * Globally hide a scorable
   * @param {number} scorableId - Scorable ID to hide
   */
  hideScorable: async (scorableId) => {
    const response = await api.put(`/admin/scorables/${scorableId}/hide`)
    return response.data
  },

  /**
   * Unhide a globally hidden scorable
   * @param {number} scorableId - Scorable ID to unhide
   */
  unhideScorable: async (scorableId) => {
    const response = await api.delete(`/admin/scorables/${scorableId}/unhide`)
    return response.data
  },

  /**
   * Report status options for UI
   */
  REPORT_STATUSES: [
    { value: 'pending', label: 'Pending', variant: 'warning' },
    { value: 'reviewed', label: 'Reviewed', variant: 'info' },
    { value: 'dismissed', label: 'Dismissed', variant: 'secondary' },
    { value: 'actioned', label: 'Actioned', variant: 'success' }
  ],

  /**
   * Report reason labels for UI
   */
  REPORT_REASONS: [
    { value: 'inappropriate', label: 'Inappropriate Content' },
    { value: 'misinformation', label: 'Misinformation' },
    { value: 'spam', label: 'Spam' },
    { value: 'dangerous', label: 'Dangerous Content' },
    { value: 'copyright', label: 'Copyright Violation' },
    { value: 'other', label: 'Other' }
  ]
}

export default adminService
